<template>
  <div>
    <el-dialog :title="$t('选择收货地址')" :visible="show" @close="$emit('close')">
      <el-table :data="addressLists" height="250" highlight-current-row @current-change="handleCurrentChange">
        <el-table-column property="receiver" :label="$t('姓名')" width="100"></el-table-column>
        <el-table-column property="phone" :label="$t('电话')" width="150"></el-table-column>
        <el-table-column property="area.names" :label="$t('地址')" width="100"></el-table-column>
        <el-table-column property="address" :label="$t('详细地址')"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer w-full text-right pr-10 mt-5">
        <!-- <el-link :to="{ name: 'Address' }" class="text-main pr-4">{{
          $t("去添加新地址")
        }}</-link> -->
        <el-link type="success" @click="goEditAddr" class="mr-2">{{ $t("去添加新地址") }}</el-link>
        <el-button type="primary" @click="modifyAddr">{{ $t("确定") }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { ref, watchEffect } from "@vue/composition-api";
export default {
  props: { show: Boolean },
  setup(props, ctx) {
    const addrMessage = ref();
    const addressLists = ref()
    const getAddressList = async () => {
      let res = await ctx.root.$callapi('user/getAddressList')
      if (res.code == 0 && res.data) {
        addressLists.value = res.data.items
      }
    }
    watchEffect(() => {
      // console.log(props.show, 'aaaaaaaaaaaaaaaaaaaaaaaa');

      if (props.show) {
        getAddressList()
      }
    })

    const handleCurrentChange = (val) => {
      addrMessage.value = val;
    };
    const modifyAddr = () => {
      if (addrMessage.value) {
        ctx.emit("modifyAddr", addrMessage.value);
      } else {
        ctx.root.$toast(ctx.root.$t("您还没有选择收货地址"), "warning");
      }
    };
    const close = () => {
    }
    const goEditAddr = async () => {
      await ctx.root.$router.push({
        name: 'Address',
      })
      await ctx.emit('close')
    }
    return { handleCurrentChange, addressLists, modifyAddr, close,goEditAddr };
  },
};
</script>
